import { useRef } from 'react';
/**
 * Returns a ref that is immediately updated with the new value
 *
 * @param value The Ref value
 * @category refs
 */

export default function useUpdatedRef(value) {
  var valueRef = useRef(value);
  valueRef.current = value;
  return valueRef;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@restart/hooks/esm/useUpdatedRef.js
// module id = 1202
// module chunks = 13